import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DataUrlPlatform } from '../interfaces/data';

@Injectable({
  providedIn: 'root'
})
export class UrlPlatformService {
  private dataUrlPlatformSubject = new Subject<DataUrlPlatform>();
  private dataUrlPlatform: DataUrlPlatform = { platform: '', url: '' };

  // devuelve datos plataforma y url
  setDataUrlPlatform(change: DataUrlPlatform) {
    this.dataUrlPlatformSubject.next(change);
    this.dataUrlPlatform = change;
  }

  getDataUrlPlatform() {
    return this.dataUrlPlatform;
  }

  getDataUrlPlatformObservable() {
    return this.dataUrlPlatformSubject.asObservable();
  }
}
